import useUpdateItem from "src/core/checkout/hooks/useUpdateItem";

function UpdateItem({item, render}) {
  const data = useUpdateItem({item});

  return render(data);
}

export default UpdateItem;
